module.exports = __webpack_public_path__ + "static/Pudding_Black-d0dbdf2d21190eada7357ef78c9ceab9.jpg";